import { CREATE_CHAT_ROOM } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CREATE_CHAT_ROOM.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CHAT_ROOM.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case CREATE_CHAT_ROOM.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
